import {
  ArrowForwardIos,
  CallSplit,
  ContentCopy,
  Delete,
  Message
} from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#ecfeff",
        padding: "8px",
        borderRadius: "14px",
        width: "185px",
        border: "1px solid #a5f3fc",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#06b6d4",
          width: "14px",
          height: "14px",
          top: "20px",
          left: "-9px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
      </div>
      <div
        style={{
          color: "#111827",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex"
        }}
      >
        <CallSplit
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#06b6d4",
          }}
        />
        <div style={{ color: "#111827", fontSize: "16px" }}>Randomizador</div>
      </div>
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "16px",
          justifyContent: "end",
          position: "relative",
          display: "flex",
          color: "#374151",
        }}
      >
        {`${data.percent}%`}
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#06b6d4",
          width: "14px",
          height: "14px",
          right: "-9px",
          marginTop: "-5px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "16px",
          justifyContent: "end",
          position: "relative",
          display: "flex",
          marginTop: "8px",
          color: "#374151",
        }}
      >
        {`${100 - data.percent}%`}
      </div>
      <Handle
        type="source"
        position="right"
        id="b"
        style={{
          background: "#06b6d4",
          width: "14px",
          height: "14px",
          right: "-9px",
          top: 73,
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
